var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleCir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 124,
    viewBox: "0 0 173 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uC81C\\uC678_2",
    "data-name": "\\uC81C\\uC678 2",
    d: "M-5076.3,124a62.419,62.419,0,0,1-19.828-3.21,62.079,62.079,0,0,1-17.189-8.933,62.356,62.356,0,0,1-13.5-13.61,61.606,61.606,0,0,1-8.763-17.241c3.674-.974,7.423-2.078,11.145-3.282,25.714-8.318,46.866-20.416,51.437-29.419a6.266,6.266,0,0,0,.672-4.825c-.619-1.9-2.44-3.357-5.414-4.342a37.734,37.734,0,0,0-11.49-1.433c-12.058,0-28.63,3.124-45.466,8.572-.68.22-1.357.443-2.014.662a61.415,61.415,0,0,1,8.188-18.709,62.3,62.3,0,0,1,13.613-14.871,62.09,62.09,0,0,1,17.814-9.816A62.343,62.343,0,0,1-5076.3,0a62.1,62.1,0,0,1,24.234,4.872,62.071,62.071,0,0,1,19.79,13.287,61.773,61.773,0,0,1,13.343,19.708A61.387,61.387,0,0,1-5014.04,62a61.382,61.382,0,0,1-4.893,24.133,61.773,61.773,0,0,1-13.343,19.707,62.071,62.071,0,0,1-19.79,13.287A62.1,62.1,0,0,1-5076.3,124Zm-93.6-37.7a37.735,37.735,0,0,1-11.491-1.433c-2.973-.984-4.794-2.445-5.413-4.342-1.339-4.1,3.114-9.838,12.539-16.146,9.4-6.294,22.741-12.486,37.557-17.436A61.979,61.979,0,0,0-5138.56,62a61.736,61.736,0,0,0,2.979,19C-5148.445,84.417-5160.634,86.3-5169.9,86.3Z",
    transform: "translate(5187.04 0)",
    fill: "#d7ccdd",
    opacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCir);
export default __webpack_public_path__ + "static/media/purple_cir.acf4b3610615705e3354196dfcbfc2dd.svg";
export { ForwardRef as ReactComponent };